import { render, staticRenderFns } from "./dailyDecisionStatistics.vue?vue&type=template&id=4c96709c&scoped=true"
import script from "./dailyDecisionStatistics.vue?vue&type=script&lang=js"
export * from "./dailyDecisionStatistics.vue?vue&type=script&lang=js"
import style0 from "./dailyDecisionStatistics.vue?vue&type=style&index=0&id=4c96709c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96709c",
  null
  
)

export default component.exports